// refer to: https://zhuanlan.zhihu.com/p/63755519
class EnvironmentSphericalHarmonics {
    constructor(sphCoef) {
        this.sphCoef = this.initSHCoef(sphCoef)
    }
    initSHCoef(sphCoef) {
        // use spherical harmonics with 9 coef
        // 使用具有9个系数的球谐函数
        var _sphCoef = sphCoef.slice(0, 9 * 3);

        var coef0 = 1.0 / (2.0 * Math.sqrt(Math.PI));
        var coef1 = -(Math.sqrt(3.0 / Math.PI) * 0.5);
        var coef2 = -coef1;
        var coef3 = coef1;
        var coef4 = Math.sqrt(15.0 / Math.PI) * 0.5;
        var coef5 = -coef4;
        var coef6 = Math.sqrt(5.0 / Math.PI) * 0.25;
        var coef7 = coef5;
        var coef8 = Math.sqrt(15.0 / Math.PI) * 0.25;

        var coef = [
            coef0,
            coef0,
            coef0,
            coef1,
            coef1,
            coef1,
            coef2,
            coef2,
            coef2,
            coef3,
            coef3,
            coef3,
            coef4,
            coef4,
            coef4,
            coef5,
            coef5,
            coef5,
            coef6,
            coef6,
            coef6,
            coef7,
            coef7,
            coef7,
            coef8,
            coef8,
            coef8
        ];

        _sphCoef = coef.map(
            function (value, index) {
                return value * _sphCoef[index];
            }
        );
        return _sphCoef;


    }
}
export default EnvironmentSphericalHarmonics